module.exports = __webpack_public_path__ + "static/media/dailyIcon4.fad5710e.svg";